import { type AbsoluteRoutePathWithAnyId, type AbsoluteRoutePathWithId, isRelativeRoutePathWithId, type RelativeRoutePathWithId } from './Domain'
import { useHasCapabilities } from './Hook.HasCapabilities'
import { useInternalRoutingHook } from './Hook.InternalRouting'

type RouteWithId = Readonly<{ path: AbsoluteRoutePathWithAnyId, redirect: (id: string) => void, createHref: (id: string) => string }>

/**
 * @returns `null` when the user lacks the capabilities to access the route
 */
export const useRouteWithId = (route: AbsoluteRoutePathWithId | RelativeRoutePathWithId): RouteWithId | null => {
    const hasCapabilities = useHasCapabilities()
    const router = useInternalRoutingHook()

    const absoluteRoute = isRelativeRoutePathWithId(route) ? router.getAbsoluteRoute(route) : route

    if (!hasCapabilities(absoluteRoute)) {
        return null
    }

    return { path: absoluteRoute, redirect: (id) => router.redirect(absoluteRoute, id), createHref: (id) => router.createHref(absoluteRoute, id) }
}
